import React, { Fragment, useEffect, useState } from 'react';
interface CountdownTimerProps {
  size?: 'compact' | 'large';
  dark?: boolean;
}
interface TimeParts {
  hours: number;
  minutes: number;
  seconds: number;
}
function getTimeParts(target: number): TimeParts {
  const remaining = Math.max(0, target - Date.now());
  return {
    hours: Math.floor(remaining / 3600000),
    minutes: Math.floor(remaining % 3600000 / 60000),
    seconds: Math.floor(remaining % 60000 / 1000)
  };
}
export function CountdownTimer({
  size = 'compact',
  dark = false
}: CountdownTimerProps) {
  const [target] = useState(() => Date.now() + 86400000);
  const [time, setTime] = useState(() => getTimeParts(target));
  useEffect(() => {
    const interval = window.setInterval(() => setTime(getTimeParts(target)), 1000);
    return () => window.clearInterval(interval);
  }, [target]);
  const large = size === 'large';
  const valueClass = large ? 'text-5xl sm:text-7xl' : 'text-xl sm:text-2xl';
  const labelClass = large ? 'text-[10px]' : 'text-[8px]';
  const parts: Array<[number, string]> = [[time.hours, 'hrs'], [time.minutes, 'min'], [time.seconds, 'sec']];
  return <div className="flex items-start justify-center gap-2 sm:gap-3" aria-label={`Offer ends in ${time.hours} hours, ${time.minutes} minutes and ${time.seconds} seconds`} data-id="element-19" data-mp="122ipg4zompoi">
      {parts.map(([value, label], index) => <Fragment key={label} data-id="element-20" data-mp="1us7r8kk7utr6" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className={`${valueClass} font-display font-bold leading-none ${dark ? 'text-gold' : 'text-ink'}`} data-id="element-21" data-mp="1zq9ihsrspzdq">
              :
            </span>}
          <div className="text-center" data-id="element-22" data-mp="1pzochk9slsks">
            <div className={`${valueClass} font-display font-bold leading-none tabular-nums ${dark ? 'text-white' : 'text-night'}`} data-id="element-23" data-mp="1pyn1ffss1632">
              {String(value).padStart(2, '0')}
            </div>
            <div className={`${labelClass} mt-1 font-bold uppercase tracking-[.18em] ${dark ? 'text-night-muted' : 'text-night-slate'}`} data-id="element-24" data-mp="2iilhc5j8qij4">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}